module.exports = __webpack_public_path__ + "img/limitManage-active.c98824e7.svg";